// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__14Kse","info":"PatientInfo_info__1WqQI"};